import InputImage from "./InputImage";

export default InputImage;
